// src/pages/auth/ResetPassword.js
// Maxula
import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI } from '../../services/api';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('8 caractères minimum');
    if (password !== confirm) return toast.error('Les mots de passe ne correspondent pas');
    try {
      setLoading(true);
      await authAPI.resetPassword(token, { password });
      toast.success('Mot de passe réinitialisé. Connectez-vous.');
      navigate('/login');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Lien invalide ou expiré');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-6">Nouveau mot de passe</h2>
        <form onSubmit={submit}>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Nouveau mot de passe (min. 8)" className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-3 focus:ring-2 focus:ring-primary-500 outline-none" />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirmer le mot de passe" className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4 focus:ring-2 focus:ring-primary-500 outline-none" />
          <button type="submit" disabled={loading}
            className="w-full py-2.5 rounded-lg bg-primary-600 text-white font-semibold hover:bg-primary-700 disabled:opacity-60">
            {loading ? 'Enregistrement…' : 'Réinitialiser'}
          </button>
          <div className="text-center mt-4">
            <Link to="/login" className="text-sm text-gray-500 hover:text-primary-600">Retour à la connexion</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
